import { ArrowDownToLine, ArrowUpFromLine, ExternalLink, History, LogIn, ShoppingBag, Undo2 } from "lucide-react";

import { hora, reais } from "../lib/caixa";

const TIPOS = {
  abertura: { icone: LogIn, rotulo: "Abertura", cor: "text-primary bg-primary/10" },
  sangria: { icone: ArrowUpFromLine, rotulo: "Sangria", cor: "text-red-600 bg-red-500/10", sinal: "−" },
  adicao: { icone: ArrowDownToLine, rotulo: "Suprimento", cor: "text-emerald-600 bg-emerald-500/10", sinal: "+" },
  // Pedido cancelado depois de virar venda (v1.5.789): a venda sai do caixa.
  estorno: { icone: Undo2, rotulo: "Estorno", cor: "text-amber-600 bg-amber-500/10", sinal: "−" },
};

/** Linha do tempo do dinheiro da gaveta; as vendas ficam resumidas numa linha só. */
export default function Movimentacoes({ movimentos, onVerPedidos }) {
  const gaveta = (movimentos || []).filter((m) => TIPOS[m.tipo]).sort((a, b) => String(a.created_at).localeCompare(String(b.created_at)));
  const vendas = (movimentos || []).filter((m) => m.tipo === "venda");
  return (
    <section className="rounded-2xl border bg-card p-4 sm:p-5" data-e2e="movimentacoes">
      <h3 className="font-bold flex items-center gap-2 mb-3"><History className="w-4 h-4 text-primary" />Movimentações</h3>
      <ol className="relative space-y-3 before:absolute before:left-[17px] before:top-2 before:bottom-2 before:w-px before:bg-border">
        {gaveta.map((m) => {
          const t = TIPOS[m.tipo];
          return (
            <li key={m.id} className="relative flex items-center gap-3">
              <span className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 z-10 ${t.cor}`}><t.icone className="w-4 h-4" /></span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium">{t.rotulo}{m.tipo === "estorno" && m.forma_pagamento_nome ? ` (${m.forma_pagamento_nome})` : ""}<span className="text-muted-foreground font-normal"> · {hora(m.created_at)}</span></p>
                {m.observacao ? <p className="text-xs text-muted-foreground truncate">{m.observacao}</p> : null}
              </div>
              <span className="tabular-nums font-semibold text-sm">{t.sinal || ""}{reais(m.valor)}</span>
            </li>
          );
        })}
        <li className="relative flex items-center gap-3">
          <span className="w-9 h-9 rounded-full flex items-center justify-center shrink-0 z-10 bg-muted"><ShoppingBag className="w-4 h-4" /></span>
          <p className="flex-1 text-sm">{vendas.length} venda(s) lançada(s) neste caixa</p>
          <button type="button" onClick={onVerPedidos} className="text-xs text-primary font-medium flex items-center gap-1 hover:underline"><ExternalLink className="w-3.5 h-3.5" />Ver pedidos</button>
        </li>
      </ol>
    </section>
  );
}
